const DataLink = {
  init() {
    if (this.loaded !== true) {
      this.loaded = false
    }
    if (!this.loaded) {
      return this.addWatcher()
    }
  },

  addWatcher() {
    this.loaded = true
    return $(document).on("click keypress", "tr[data-link]", function dataLinkClick(e) {
      if (
        e.type === "click" ||
        (e.type === "keypress" &&
          (e.key === "Enter" ||
            e.key === " " ||
            e.key === "Spacebar" ||
            e.which === 13 ||
            e.which === 32))
      ) {
        Turbolinks.visit(this.dataset.link)
      }
    })
  },

  initialize() {
    $(document).on("page:load", () => Sprinkles.DataLink.init())
  }
}

export default DataLink
